import { format, isDate, isValid, parseISO } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { Flex, Text } from 'ui';

type P = {
  time?: string;
};

const CalendarIcon = ({ time }: P) => {
  const { t } = useTranslation();
  const parsedDate = parseISO(time ?? '');
  const isValidDate = isDate(parsedDate) && isValid(parsedDate);

  return (
    <Flex align="center" className="calendar-icon" justify="center" vertical>
      <Text type="primary">{isValidDate ? format(parsedDate, 'dd') : ''}</Text>
      <Text type="primary">{t('dateFormats.shortMonth', { date: parsedDate })}</Text>
    </Flex>
  );
};

export default CalendarIcon;
